import { Outlet } from 'react-router-dom';
import { ClientHeader } from 'pages';

const RootLayoutClient = () => {
  return (
    <div className="flex flex-col min-h-screen bg-bgColor gap-y-6 md:gap-y-4 px-[30px] md:px-4 pt-safe pb-safe overflow-x-hidden w-full max-w-full">
      <ClientHeader />
      <div className="flex w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default RootLayoutClient;
